
import { Middleware, Dispatch, MiddlewareAPI, AnyAction    } from 'redux';
import axios, { AxiosResponse } from 'axios';

import {RefreshTokenRequest, RefreshTokenResponse} from '../interface/IRefreshToken';

import helper from '../helpers/index';
import LoginService from '../pages/Login/LoginService';
import { get } from 'http';



const RefreshTokenMiddleware =
  (store: any) =>
  (next: any) =>
  async (action: any) => {
    try
    {
      var currentUrl = window.location.href;
      var role =  helper.getCookieValue('role');

      if(role == 'Admin'){
       
        if(currentUrl.toLowerCase().indexOf("/admin/") < 0){
       
            return false;
        }
      }
      else if(role == 'Member'){
        if(currentUrl.toLowerCase().indexOf("/members/") < 0 ){
         
          return false;
        }
      }
      else{
      
        return false;
      }

      var refreshToken: string = helper.getCookieValue('refreshToken');

      IsCookieExists(refreshToken);

      await RefreshToken(refreshToken);


      return next(action);
      
    }
    catch(error){
      return false;

    }
  };



  async function RefreshToken(refreshTokenParam: string){

    try
    {

      var expirationDateTime: string = helper.getCookieValue('refreshTokenExpiration');
      IsCookieExists(expirationDateTime);
      var expDateTime: Date = new Date(expirationDateTime);

      var currentDateTimeIsoString = new Date().toISOString();


      var currentDateTime = new Date(currentDateTimeIsoString);

      var timeDiffMs: number = expDateTime.getTime() - currentDateTime.getTime();

      var timeDiffMinutes: number = timeDiffMs / (1000 * 60);

      var threashold:number = Number(process.env.REACT_APP_TOKEN_THRESHOLD);
      
      if(threashold > timeDiffMinutes){


        var payload: RefreshTokenRequest = {
          refreshToken : refreshTokenParam,
          role: helper.getCookieValue('role')
        }

        var response =  await GetRefreshToken(payload);



        if (response.status >= 200 && response.status < 300) {

          var responseRefreshToken = response.data.result.refreshToken;
          var responseRefreshTokenExpiration = new Date(response.data.result.refreshTokenExpiration);
          var responseUsername = response.data.result.username;
          var permission = response.data.result.permission;
          var role = response.data.result.role;


          LoginService.SetLoginToken(responseRefreshToken,responseRefreshTokenExpiration,responseUsername, permission, role);


        }
        else{
            
            throw new Error(response.data.message);  
        }

      }


    
    }
    catch(error){
      console.log('RefreshToken error:: ', error);
      
      throw error;
    }
  }

  function IsCookieExists(value: string){
    if(!value){
   
      throw new Error('Cookie not found');
    }
  }

async function GetRefreshToken(payload: RefreshTokenRequest) : Promise<AxiosResponse<RefreshTokenResponse>>{
  try
  {
    
    var apiUrl = process.env.REACT_APP_API_URL + '/Login/refreshtoken';


    var response : AxiosResponse<RefreshTokenResponse> = await axios.post(apiUrl, payload,{
      headers: {
          'Content-Type': 'application/json'
      },
      withCredentials : true
    });

    return response;

  }
  catch(error){
    console.log(error);

    throw error;
  }
}


export default RefreshTokenMiddleware;